import { all, put, call, takeLatest } from '@redux-saga/core/effects';
import {
  createAgreementRequestHelper,
  downloadAgreementRequestHelper,
  downloadPDFAgreementRequestHelper,
} from '../../util/helpers/agreementRequestHelper';
import { rejectErrorCodeHelper } from '../../util/helpers/registerRejectErrorCodeHelper';
import {
  CREATE_AGREEMENT,
  DOWNLOAD_AGREEMENT,
  DOWNLOAD_PDF_AGREEMENT,
} from '../actions/agreement/agreementActionConstants';
import {
  createAgreementError,
  createAgreementSuccess,
  downloadAgreementSuccess,
  downloadAgreementError,
  downloadPdfAgreementSuccess,
  downloadPdfAgreementError,
} from '../actions/agreement/agreementActions';

function* downloadAgreement({ payload }) {
  try {
    const downloadAgreementRequest = downloadAgreementRequestHelper(
      payload?.type,
    );

    const { data } = yield call(downloadAgreementRequest, {
      ApplicationUid: payload.ApplicationUid,
    });

    yield put(downloadAgreementSuccess(data));
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(downloadAgreementError(errorMessage));
  }
}

function* downloadPdfAgreement({ payload }) {
  try {
    const downloadPDFAgreementRequest = downloadPDFAgreementRequestHelper(
      payload?.type,
    );

    const { data } = yield call(downloadPDFAgreementRequest, {
      ApplicationUid: payload.ApplicationUid,
    });
    const downloadUrl = window.URL.createObjectURL(data);
    window.open(downloadUrl, '_blank');
    yield put(downloadPdfAgreementSuccess(data));
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(downloadPdfAgreementError(errorMessage));
  }
}

function* createAgreement({ payload }) {
  try {
    const createAgreementRequest = createAgreementRequestHelper(payload?.type);

    const { status } = yield call(createAgreementRequest, {
      ApplicationUid: payload.ApplicationUid,
      data: payload.data,
    });
    if (status === 202) {
      yield put(createAgreementSuccess());
      if (payload?.onSuccess) {
        yield call(payload?.onSuccess);
      }
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(createAgreementError(errorMessage));
  }
}

export default function* agreementSaga() {
  return yield all([
    takeLatest(DOWNLOAD_AGREEMENT, downloadAgreement),
    takeLatest(DOWNLOAD_PDF_AGREEMENT, downloadPdfAgreement),
    takeLatest(CREATE_AGREEMENT, createAgreement),
  ]);
}
